export default "__VITE_PUBLIC_ASSET__60b42d37__"